import { render, staticRenderFns } from "./PreApproveRiskModelV2.vue?vue&type=template&id=46f8e5e0&scoped=true&"
import script from "./PreApproveRiskModelV2.vue?vue&type=script&lang=js&"
export * from "./PreApproveRiskModelV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f8e5e0",
  null
  
)

export default component.exports